module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfCRc4EsA.2522a38e.woff2";